import { authFetch } from "./base";
export const fetchTestRecordings = async () => {
    const response = await authFetch(`api/testing/recordings`);
    if (!response.ok) {
        throw new Error(`Failed to fetch test recordings`);
    }
    const json = await response.json();
    return json.data;
};
